import {
  REQUEST_INTEGRATIONS_TYPES,
  RESPONSE_INTEGRATIONS_TYPES,
  REQUEST_INTEGRATIONS_TYPES_FAILURE,
  REQUEST_INTEGRATIONS,
  RESPONSE_INTEGRATIONS,
  REQUEST_INTEGRATIONS_FAILURE,
  REQUEST_INTEGRATION_CREATE,
  RESPONSE_INTEGRATION_CREATE,
  REQUEST_INTEGRATION_CREATE_FAILURE,
  REQUEST_INTEGRATION_DELETE,
  RESPONSE_INTEGRATION_DELETE,
  REQUEST_INTEGRATION_DELETE_FAILURE,
} from "../actions/integrationsActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  integrationsDataState: queriesStates.NOT_REQUESTED,
  integrationTypesDataState: queriesStates.NOT_REQUESTED,
  integrationCreateDataState: queriesStates.NOT_REQUESTED,
  integrationDeleteDataState: queriesStates.NOT_REQUESTED,
  integrations: [],
  integrationTypes: [],
  errors: [],
};

const integrationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_INTEGRATIONS_TYPES: {
      return Object.assign({}, state, {
        integrationTypesDataState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_INTEGRATIONS_TYPES: {
      return Object.assign({}, state, {
        integrationTypesDataState: queriesStates.READY,
        integrationTypes: action.data.types,
      });
    }
    case REQUEST_INTEGRATIONS_TYPES_FAILURE: {
      return Object.assign({}, state, {
        integrationTypesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_INTEGRATIONS: {
      return Object.assign({}, state, {
        integrationsDataState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_INTEGRATIONS: {

      return Object.assign({}, state, {
        integrationsDataState: queriesStates.READY,
        integrations: action.data.integrations,
      });
    }
    case REQUEST_INTEGRATIONS_FAILURE: {
      return Object.assign({}, state, {
        integrationsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_INTEGRATION_CREATE: {
      return Object.assign({}, state, {
        integrationCreateDataState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_INTEGRATION_CREATE: {
      const data = action.data;

      data.title = state.integrationTypes.filter((x) => {
        return x.id === data.type;
      })[0].title;

      return Object.assign({}, state, {
        integrationCreateDataState: queriesStates.READY,
        integrations: state.integrations.concat(action.data),
      });
    }
    case REQUEST_INTEGRATION_CREATE_FAILURE: {
      return Object.assign({}, state, {
        integrationCreateDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_INTEGRATION_DELETE: {
      return Object.assign({}, state, {
        integrationDeleteDataState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_INTEGRATION_DELETE: {
      return Object.assign({}, state, {
        integrationDeleteDataState: queriesStates.READY,
        integrations: state.integrations.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    }
    case REQUEST_INTEGRATION_DELETE_FAILURE: {
      return Object.assign({}, state, {
        integrationDeleteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default integrationsReducer;
